export default __webpack_public_path__ + "static/media/SAlogoold.6b94eae3.png";